import { ArrowRight, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinalCta() {
  return <section id="contact-cta" aria-labelledby="final-cta-heading" className="bg-background py-20 lg:py-28 text-foreground">
      <div className="container mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl bg-primary text-primary-foreground p-8 sm:p-12 lg:p-16 text-center shadow-lg">
          <div className="max-w-3xl mx-auto space-y-6">
            <h2 id="final-cta-heading" className="text-2xl sm:text-3xl lg:text-4xl font-bold font-serif tracking-tight text-primary-foreground">
              Ready to Work Directly With a Freelance SEO Consultant?
            </h2>

            <p className="text-base sm:text-lg text-primary-foreground/90 font-sans leading-relaxed max-w-2xl mx-auto">
              Tell me about your business, your website, and the organic search goals you want to achieve. I will review your requirements and reply with practical next steps, without pressure.
            </p>

            <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" variant="secondary" className="w-full sm:w-auto bg-background text-foreground hover:bg-background/90 font-medium px-6 py-3 shadow-xs">
                <Link to="/ContactPage">
                  Book a Free SEO Consultation
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Link>
              </Button>

              <Button asChild size="lg" variant="outline" className="w-full sm:w-auto border-primary-foreground/30 bg-primary-foreground/10 text-primary-foreground hover:bg-primary-foreground/20 font-medium px-6 py-3">
                <Link to="/ContactPage?topic=free-seo-audit">
                  Get a Free SEO Audit
                </Link>
              </Button>
            </div>

            <div className="pt-2">
              <a href="mailto:contact@ye-consultancy.com" className="inline-flex items-center gap-2 text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors underline font-medium">
                <Mail className="w-4 h-4" />
                Email me about your project
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}